import api, { upload } from 'utils/axios';

import { accountIdSelector } from '../user/selectors';

export const getFontsThunk = () => async (_dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());

  try {
    const response = await api.get(`/acc/${accountId}/fonts?limit=1000`);

    return response;
  } catch (err) {
    throw err.errors.source;
  }
};

export const addFontThunk = (values) => async (_dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  const payload = new FormData();
  payload.append('file', values.file);
  payload.append('font_family', values.fontFamily);
  payload.append('font_style', values.fontStyle);
  payload.append('font_weight', values.fontWeight);

  try {
    const response = await upload(`/acc/${accountId}/fonts`, 'POST', payload);

    return response;
  } catch (err) {
    throw err.errors.source;
  }
};

export const removeFontThunk =
  ({ id }) =>
  async (dispatch, getStore) => {
    const accountId = accountIdSelector(getStore());

    try {
      const response = await api.delete(`/acc/${accountId}/fonts/${id}`);

      return response;
    } catch (err) {
      throw err.errors.source;
    }
  };
